<div class="column-selection mat-elevation-z2">
  @let columns = (columns$ | async) ?? [];
  <div class="row select-all">
    @let allVisible = (allColumnsVisible$ | async) ?? false;
    @let someVisible = (someColumnsVisible$ | async) ?? false;
    <mat-checkbox (change)="toggleSelectAll()"
                  i18n-tmTooltip="@@core.attribute-list.toggle-all-columns-visibility"
                  tmTooltip="Toggle visibility of all columns"
                  i18n-aria-label="@@core.attribute-list.toggle-all-columns-visibility"
                  aria-label="Toggle visibility of all columns"
                  [checked]="allVisible"
                  [indeterminate]="someVisible && !allVisible"></mat-checkbox>
    <div class="label"></div>
    <button mat-icon-button
            (click)="closeOverlay()"
            i18n-tmTooltip="@@core.attribute-list.close-column-settings"
            tmTooltip="Close column settings">
      <mat-icon class="close" svgIcon="close"></mat-icon>
    </button>
  </div>
  <div class="list" cdkDropList (cdkDropListDropped)="drop($event, columns)">
    @for (column of columns; track trackByColumnId($index, column)) {
      <div class="row" cdkDrag [cdkDragData]="column" cdkDragLockAxis="y">
        <div class="placeholder" *cdkDragPlaceholder>{{column.label}}</div>
        <div class="preview" *cdkDragPreview></div>
        <mat-checkbox (change)="toggleVisible(column)" [checked]="column.visible" class="toggle-column-checkbox">
            {{column.label}}
        </mat-checkbox>
        <mat-icon class="drag-handle" svgIcon="reorder" cdkDragHandle></mat-icon>
      </div>
    }
  </div>
</div>
